export default __webpack_public_path__ + "static/pragicts-partnerships-banner-force-to-reckon-with-99968a66c18e2c86bc1a6e83b5e5fc22.jpg";